import { render, staticRenderFns } from "./MediaStorageCropper.vue?vue&type=template&id=70d0e586&"
import script from "./MediaStorageCropper.vue?vue&type=script&lang=js&"
export * from "./MediaStorageCropper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports